export default __webpack_public_path__ + "resources/icons/n331-f69e.png";